export default __webpack_public_path__ + "static/media/IconDesc_EmptyCannister.256.cb80496b.png";